import axios from 'axios';
import { IFreshServiceTicketUpsert } from '../../../@types/model/freshService/freshServiceTicketUpsert';

export default class FreshServiceHttpService {
    public static upsert = async (ticketValues : IFreshServiceTicketUpsert) : Promise<void> => {
        return await axios.post(`${API_URL}/v1/FreshService/CreateTicket`, ticketValues);
    };
}
